import React from 'react';
import '../styles/nav.scss';
// import Countdown from './Countdown';
import msLogo from '../assets/msLogo.svg';

const Nav = ({ showMobileMenu, navRef }) => {
  const linksData = [
    {
      key: 1,
      text: 'the access I',
      url: '#access1'
    },
    {
      key: 2,
      text: 'film',
      url: '#film'
    },
    {
      key: 3,
      text: 'installation',
      url: '#event'
    },
    {
      key: 4,
      text: 'photo gallery',
      url: '#gallery'
    },
    {
      key: 5,
      text: 'interactive',
      url: '#interactive'
    },

    {
      key: 6,
      text: 'the next generation',
      url: '#generation'
    },

    {
      key: 7,
      text: 'Explore the New Space Economy',
      url: 'https://www.morganstanley.com/Themes/global-space-economy/?cid=mg-cap-cnncreat-12577',
      content: 'external'
    }
  ];
  return (
    <nav className="nav" ref={navRef}>
      <img src={msLogo} alt="" className="nav__logo" />
      {/* <div className="nav__event">
        <h4 className="join">JOIN US TODAY</h4>
        <button className="nav__event__button">
          <a href="#eventPoster">Event Details </a>
        </button>
      </div> */}
      <div className="nav__contents">
        {linksData.map((link, i) => (
          <a
            key={link.key}
            href={link.url}
            target={link.key === 7 ? '_blank' : ''}
            rel={link.content ? 'sponsored noopener' : 'sponsored'}
            className="nav__desktop"
          >
            {link.text}
            {i === linksData.length - 1 ? (
              <svg
                className="nav__arrow"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.844238 1.92456L14.8442 8.00003L0.844238 14.0755"
                  stroke="white"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinejoin="round"
                  className="nav__arrow__stroke"
                />
              </svg>
            ) : (
              ''
            )}
          </a>
        ))}
      </div>

      <button className="nav__menu" aria-controls="menu" onClick={showMobileMenu}>
        <div className="nav__menu__bar navBar__menu__bar-top" />
        <div className="nav__menu__bar nav__menu__bar-bttm" />
      </button>
    </nav>
  );
};

export default Nav;
